module.exports = __webpack_public_path__ + "static/media/marcaApuestas.58c46cc9.png";